<template>
  <div class="widM padTM pf23Wrap padBML" >
    <div class="txtC padBM" style="border-bottom:1px solid #ddd;">
      <img src="https://www.amway.co.kr/_ui/_noticeImg/logo/logo_amway_ci.png" alt="Amway (로고)" class="icoS"
        style="max-width:115px;">
    </div>
    <p class="pf23-tit fntH4 fntL bold marBS padTML txtC" style="color:#00305e; letter-spacing: normal;">신청이 완료되었습니다.</p>
    <p class="pf23-tit fntH4 marBL txtC" style="color:#2c2c2c; letter-spacing: normal;">아래 신청 내용을 확인해 주세요.</p>

    <div class="pf23-inFo-wrap">
      <div class="widM clearfix">
        <template v-for="(attend, idx) in attendingList">
          <hr :key="`hr-${idx}`" v-if="idx > 0" class="moOnly" style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;">
          <div class="widM" :key="idx" :class="{'floL' : (idx == 0), 'floR' : (idx == 1)}">
            <p class="fntH6 fntL bold marBM" style="color:#2c2c2c; width:49%;">{{aboType(idx)}}</p>
      
            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23Name01" class="fntP">이름</label>
              <input type="text" id="pf23Name01" name="pf23Name01" :value="aboName(idx)">
            </div>

            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23Abo01" class="fntP">ABO 번호</label>
              <input type="text" id="pf23Abo01" name="pf23Abo01" :value="aboNumber(idx)">
            </div>

            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23Num01" class="fntP">휴대폰 번호</label>
              <input type="text" id="pf23Num01" name="pf23Num01" :value="`010-${answer(idx, 'Q031')}`">
            </div>

            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23Num01" class="fntP">내국인 구분</label>
              <input type="text" id="pf23Num01" name="pf23Num01" :value="domestic(idx, 'Q032')">
            </div>

            <div class="pf23-complet-common padBSM padTSM pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23Personal01-1" class="fntP" style="width:45%;">{{country(idx, 'Q032')}}</label>
              <em class="txtR disIb" style="width:55%;"><input type="text" name="pf23Personal01-1" id="pf23Personal01-1"
                  maxlength="6" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                  style="width:45%" :value="answer(idx, 'Q033_1')"><span class="disIb txtC" style="width:10%;">-</span><input type="text" id="pf23Personal01-1-2"
                  name="pf23Personal01-1" maxlength="7"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" 
                  style="width:45%;" :value="answer(idx, 'Q033_2')"></em>
            </div>

            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23en-first01" class="fntP">영문 성</label>
              <input type="text" id="pf23en-first01" name="pf23en-first01" :value="answer(idx, 'Q034_1')">
            </div>
            
            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23en-name01" class="fntP">영문 이름</label>
              <input type="text" id="pf23en-name01" name="pf23en-name01" :value="answer(idx, 'Q034_2')">
            </div>

            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23-gender01" class="fntP">성별</label>
              <input type="text" id="pf23-gender01" name="pf23-gender01" :value="gender(idx, 'Q035')">
            </div>

            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23-country01" class="fntP">국가</label>
              <input type="text" id="pf23-country01" name="pf23-country01" :value="answer(idx, 'Q036')">
            </div>

            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23Passport-Num01" class="fntP">여권번호</label>
              <input type="text" id="pf23Passport-Num01" name="pf23Passport-Num01" :value="answer(idx, 'Q037')">
            </div>

            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23Passport-issu01" class="fntP">여권발급일</label>
              <input type="text" id="pf23Passport-issu01" name="pf23Passport-issu01" :value="answer(idx, 'Q038')">
            </div>

            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23Passport-date01" class="fntP">여권만료일</label>
              <input type="text" id="pf23Passport-date01" name="pf23Passport-date01" :value="answer(idx, 'Q039')">
            </div>

            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23Passport-date01" class="fntP">안전확인</label>
              <input type="text" id="pf23Passport-date01" name="pf23Passport-date01" :value="booleanAnswer(idx, 'Q040')" >
            </div>

            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23Active01" class="fntP">Day-3 액티비티</label>
              <input type="text" id="pf23Active01" name="pf23Active01" :value="activityAnswer(idx, 'Q029')">
            </div>
            <div class="padBSM padTSM pf23-complet-common pf23-lineBtm" :class="{'pf23-complet-L' : (idx==0), 'pf23-complet-R' : (idx==1)}">
              <label for="pf23Return01" class="fntP">귀국일<br><em>(싱가포르 - 한국)</em></label>
              <input type="text" id="pf23Return01" name="pf23Return01" :value="scheduleAnswer(idx, 'Q030')">
            </div>
          </div>

          
        </template>
    
      </div>
    </div>
      
    <div class="widM txtC marTML">
      <button class="bt-akl-blue large pf23-submit" @click="$emit('edit', true)">수정하기</button>
      <p class="txtC padTS moTxtL">* 본 화면을 벗어나더라도 신청기간 내에 URL을 통해 다시 수정하실 수 있습니다.</p>
    </div>
    
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  SURVEY_SINGAPORE,
  ATTENDING_LIST,
  GET_CODE_COUNTRY,
  GET_CODE_ABO_TYPE,
  GET_CODE_GENDER ,
  SCHEDULE_QUESTIONS,
  ACTIVITY_QUESTIONS,
} from '@/store/actions/survey'

export default {
  name: 'SurveyCompleted',
  props : {
    edit: {
      type: Boolean, 
      default: false
    },
    mode: {
      type: String, 
      default: 'E'
    }
  },
  computed : {
    ...mapGetters(SURVEY_SINGAPORE, {
      attendingList: ATTENDING_LIST,
      counties : GET_CODE_COUNTRY,
      aboTypes: GET_CODE_ABO_TYPE,
      genders: GET_CODE_GENDER ,
      scheduleQuestions: SCHEDULE_QUESTIONS,
      activityQuestions: ACTIVITY_QUESTIONS,
    }),
    editable() { 
      return this.edit || false
    },
  },
  methods: {
    aboType(idx){
      return this.aboTypes[this.attendingList[idx].type] + (this.attendingList[idx].type == 'P' ? ` ${this.attendingList[idx].type_seq}` : '');
    },
    aboName(idx) {
      return this.attendingList[idx]['name'];
    },
    aboNumber(idx) {
      return this.attendingList[idx]['abo_uid'];
    },
    answer(idx, sq_code) {
      return this.attendingList[idx].questions[sq_code].raw_data;
    },
    booleanAnswer(idx, sq_code) {
      return this.attendingList[idx].questions[sq_code].raw_data === 'Y' ? '예' : '아니오';
    },
    gender(idx, sq_code){  
      return this.genders[this.attendingList[idx].questions[sq_code].raw_data];
    },
    domestic(idx, sq_code) {
      return this.attendingList[idx].questions[sq_code].raw_data === 'DOMESTIC' ? '내국인' : '외국인';
    },
    scheduleAnswer(idx, sq_code){
      const data = this.attendingList[idx].questions[sq_code][0]
      if ( this.scheduleQuestions[data.sq_code]) {
        return this.scheduleQuestions[data.sq_code].examples[data.se_code].display_text;      
      } else { 
        return ''
      }
    },
    activityAnswer(idx, sq_code){
      const data = this.attendingList[idx].questions[sq_code][0]
      if ( this.activityQuestions[data.sq_code] && this.activityQuestions[data.sq_code].examples[data.se_code]) { 
        return this.activityQuestions[data.sq_code].examples[data.se_code].display_text;      
      } else {
        return '선택 안함'
      }
    },
    country(idx, sq_code) { 
      return this.attendingList[idx].questions[sq_code].raw_data === 'DOMESTIC' ? '주민등록번호' : '외국인등록번호';
    }
  },
}
</script>

<style scoped>
.box_renew-loading .box_loading-area {
    display: flex;
    width: 80px;
    height: 80px;
    margin: auto;
    border-radius: 50%;
    background: #fff;
    justify-content: center;
    align-items: center;
    box-shadow: 1px 1px 20px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
}
.box_renew-loading .box_loading-area img {
  width: 60px;
}
</style>


// WEBPACK FOOTER //
// src/views/surveys/singapore/components/SurveyCompleted.vue